import { NewProjectJourneyStep } from "../../../../models";
import { NewProjectJourneyStepDefinition } from "./NewProjectJourneyContext";
import { ProjectAccessStep } from "./ProjectAccessStep";
import { ProjectDetailsStep } from "./ProjectDetailsStep";

// The full journey. A host that needs fewer steps passes its own list to the provider.
export const NEW_PROJECT_JOURNEY_DEFAULT_STEPS: NewProjectJourneyStepDefinition[] = [
  { key: NewProjectJourneyStep.DETAILS, Component: ProjectDetailsStep },
  { key: NewProjectJourneyStep.ACCESS, Component: ProjectAccessStep },
];
